import doc             from '@widesk-core/decorators/doc';
import model           from '@widesk-core/decorators/model';
import MapServiceModel from '@/models/MapServiceModel';
import TimestampAble   from '@widesk-core/models/traits/TimestampAble';
import Blamable        from '@/models/traits/Blamable';

@model.cacheDuration()
@model.urnResource('import_type')
@doc.path('/import_types/{?id}')
export default class ImportTypeModel extends Blamable(TimestampAble(MapServiceModel)) {
	private declare _tsFilters: {
		'reference': Map_ImportTypeReference;
	};

	private declare _tsSorts: {
		'id': string;
		'label': string;
		'reference': string;
	};

	@doc.string declare label: string;
	@doc.string declare reference: Map_ImportTypeReference;
}